module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.projectID == '') ? _c('div', [_c('div', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("common.no_project_loaded")) + ".")])])]) : (!_vm.hasData) ? _c('div', [_c('div', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t("common.no_data_loaded")))])])]) : _c('div', [_c('div', {
    staticClass: "card"
  }, [_c('help', {
    attrs: {
      "reflink": "scenarios",
      "label": _vm.$t("scenarios.Define scenarios")
    }
  }), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-hover table-striped",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allActive),
      expression: "allActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allActive) ? _vm._i(_vm.allActive, null) > -1 : (_vm.allActive)
    },
    on: {
      "click": function($event) {
        return _vm.modalDeselectAllScens()
      },
      "change": function($event) {
        var $$a = _vm.allActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allActive = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allActive = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allActive = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Type")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Databook")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Actions")))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.scenSummaries), function(scenSummary) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (scenSummary.active),
        expression: "scenSummary.active"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(scenSummary.active) ? _vm._i(scenSummary.active, null) > -1 : (scenSummary.active)
      },
      on: {
        "click": function($event) {
          return _vm.uncheckSelectAll()
        },
        "change": function($event) {
          var $$a = scenSummary.active,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(scenSummary, "active", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(scenSummary, "active", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(scenSummary, "active", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', [_c('b', [_vm._v(_vm._s(scenSummary.name))])]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(scenSummary.scen_type === "budget" ? _vm.$t("scenarios.budget") : _vm.$t("scenarios.coverage")) + "\n          ")]), _vm._v(" "), _c('td', [_vm._v("\n            " + _vm._s(scenSummary.model_name) + "\n          ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "white-space": "nowrap"
      }
    }, [_c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("scenarios.Edit scenario")
      },
      on: {
        "click": function($event) {
          return _vm.editScenModal(scenSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-pencil"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("scenarios.Copy scenario")
      },
      on: {
        "click": function($event) {
          return _vm.copyScen(scenSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-files"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("scenarios.Convert scenario type")
      },
      on: {
        "click": function($event) {
          return _vm.convertScen(scenSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-control-shuffle"
    })]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-icon",
      attrs: {
        "data-tooltip": _vm.$t("scenarios.Delete scenario")
      },
      on: {
        "click": function($event) {
          return _vm.deleteScen(scenSummary)
        }
      }
    }, [_c('i', {
      staticClass: "ti-trash"
    })])])])
  }), 0)]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calculateCostEff),
      expression: "calculateCostEff"
    }],
    attrs: {
      "type": "checkbox",
      "id": "costeff_checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.calculateCostEff) ? _vm._i(_vm.calculateCostEff, null) > -1 : (_vm.calculateCostEff)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.calculateCostEff,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.calculateCostEff = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.calculateCostEff = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.calculateCostEff = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "costeff_checkbox"
    }
  }, [_vm._v(_vm._s(_vm.$t("scenarios.Perform intervention cost-effectiveness analysis")))])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn __green",
    attrs: {
      "disabled": !_vm.scenariosLoaded || !_vm.anySelected
    },
    on: {
      "click": function($event) {
        return _vm.runScens(0)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("scenarios.Run scenarios")))]), _vm._v(" "), _c('button', {
    staticClass: "btn __green",
    attrs: {
      "disabled": !_vm.scenariosLoaded || _vm.calculateCostEff || !_vm.anySelected
    },
    on: {
      "click": function($event) {
        return _vm.UncertScensModal(10)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("scenarios.Run scenarios with uncertainty")))]), _vm._v(" "), _c('button', {
    staticClass: "btn __blue",
    attrs: {
      "disabled": !_vm.scenariosLoaded
    },
    on: {
      "click": function($event) {
        return _vm.addScenModal('coverage')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("scenarios.Add coverage scenario")))]), _vm._v(" "), _c('button', {
    staticClass: "btn __blue",
    attrs: {
      "disabled": !_vm.scenariosLoaded
    },
    on: {
      "click": function($event) {
        return _vm.addScenModal('budget')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("scenarios.Add budget scenario")))])])], 1)]), _vm._v(" "), (_vm.hasGraphs) ? _c('div', {
    staticClass: "card full-width-card"
  }, [_c('div', {
    staticClass: "calib-title"
  }, [_c('help', {
    attrs: {
      "reflink": "results-plots",
      "label": "Results"
    }
  }), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("Zoom out")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(0.9)
      }
    }
  }, [_vm._v("–")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("common.Reset zoom")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(1.0)
      }
    }
  }, [_c('i', {
    staticClass: "ti-zoom-in"
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-icon",
    attrs: {
      "data-tooltip": _vm.$t("common.Zoom in")
    },
    on: {
      "click": function($event) {
        return _vm.scaleFigs(1.1)
      }
    }
  }, [_vm._v("+")]), _vm._v("\n           \n        "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.exportGraphs(_vm.projectID, 'scens')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.Export plots")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        return _vm.exportResults(_vm.projectID, 'scens')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("common.Export results")))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "calib-main",
    class: {
      'calib-main--full': true
    }
  }, [_c('div', {
    staticClass: "calib-graphs"
  }, [_c('div', {
    staticClass: "other-graphs"
  }, _vm._l((_vm.placeholders), function(index) {
    return _c('div', {
      staticClass: "calib-graph",
      attrs: {
        "id": 'fig' + index
      }
    })
  }), 0)])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.hasTable) ? _c('div', [_c('help', {
    attrs: {
      "reflink": "cost-effectiveness",
      "label": _vm.$t("scenarios.Program cost-effectiveness")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "calib-graphs",
    staticStyle: {
      "display": "inline-block",
      "text-align": "right",
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-hover table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("scenarios.Scenario/program")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Outcomes")))]), _vm._v(" "), _vm._l((_vm.table[0].length - 3), function(i) {
    return _c('th')
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((_vm.table), function(rowdata) {
    return _c('tr', _vm._l(((rowdata.length - 1)), function(i) {
      return _c('td', [(rowdata[0] === 'header') ? _c('span', {
        staticStyle: {
          "font-size": "15px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'keys' && i == 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-style": "italic"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'keys' && i != 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'entry' && i == 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px",
          "font-weight": "bold"
        }
      }, [_vm._v(_vm._s(rowdata[i]))]) : (rowdata[0] === 'entry' && i != 1) ? _c('span', {
        staticStyle: {
          "font-size": "12px"
        }
      }, [_vm._v("                 " + _vm._s(rowdata[i]))]) : _c('span', [_c('div', {
        staticStyle: {
          "min-height": "30px"
        }
      })])])
    }), 0)
  }), 0)])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "add-scen",
      "height": "auto",
      "scrollable": true,
      "width": '90%',
      "classes": ['v--modal', 'vue-dialog', 'grrmodal'],
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": false
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [(_vm.addEditModal.mode == 'add') ? _c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("scenarios.Add scenario")) + "\n        ")]) : _c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n          " + _vm._s(_vm.$t("scenarios.Edit scenario")) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t("scenarios.Scenario name")) + ":")]), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.scenSummary.name),
      expression: "addEditModal.scenSummary.name"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.addEditModal.scenSummary.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.addEditModal.scenSummary, "name", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t("scenarios.Databook")) + ":")]), _c('br'), _vm._v(" "), _c('tr', [_c('th', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addEditModal.scenSummary.model_name),
      expression: "addEditModal.scenSummary.model_name"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.addEditModal.scenSummary, "model_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.modalSwitchDataset]
    }
  }, _vm._l((_vm.datasetOptions), function(dataset) {
    return _c('option', [_vm._v("\n                " + _vm._s(dataset) + "\n              ")])
  }), 0), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "scrolltable",
    staticStyle: {
      "max-height": "80vh"
    }
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "100"
    }
  }, [_c('div', {
    staticClass: "dialog-header"
  }, [(_vm.addEditModal.modalScenarioType === 'coverage') ? _c('span', [_vm._v(_vm._s(_vm.$t("scenarios.Program coverages")) + " (%)")]) : _c('span', [_vm._v(_vm._s(_vm.$t("scenarios.Program spending")))])])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t("Name")))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t("Include")) + "?")]), _vm._v(" "), _vm._l((_vm.defaultScenYears.slice(0, 1)), function(year) {
    return _c('th', [_vm._v(_vm._s(year - 1))])
  }), _vm._v(" "), _vm._l((_vm.defaultScenYears), function(year) {
    return _c('th', [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('tbody', _vm._l((this.addEditModal.scenSummary.progvals), function(progvals) {
    return _c('tr', [_c('td', {
      staticStyle: {
        "min-width": "200px"
      }
    }, [_vm._v("\n                  " + _vm._s(progvals.name) + "\n                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (progvals.included),
        expression: "progvals.included"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(progvals.included) ? _vm._i(progvals.included, null) > -1 : (progvals.included)
      },
      on: {
        "change": function($event) {
          var $$a = progvals.included,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(progvals, "included", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(progvals, "included", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(progvals, "included", $$c)
          }
        }
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [(_vm.addEditModal.modalScenarioType === 'coverage') ? _c('span', [_vm._v(_vm._s(progvals.base_cov))]) : _c('span', [_vm._v("                                            " + _vm._s(progvals.base_spend))])]), _vm._v(" "), _vm._l((progvals.vals), function(val, index) {
      return _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (progvals.vals[index]),
          expression: "progvals.vals[index]"
        }],
        staticClass: "txbox",
        staticStyle: {
          "text-align": "right"
        },
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (progvals.vals[index])
        },
        on: {
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(progvals.vals, index, $event.target.value)
          }
        }
      })])
    })], 2)
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "data-tooltip": "Deselect all interventions"
    },
    on: {
      "click": function($event) {
        return _vm.modalDeselectAllProgs()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("Deselect all")))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.modalSave()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("Save")) + "\n          ")]), _vm._v("\n             \n          "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('add-scen')
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t("Cancel")) + "\n            ")])])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "uncert-nruns",
      "height": "auto",
      "classes": ['v--modal', 'vue-dialog'],
      "width": 400,
      "pivot-y": 0.3,
      "adaptive": true,
      "clickToClose": false
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-c-title"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("uncertainty.Input uncertainty runs")) + "\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-c-text"
  }, [_vm._v("\n        " + _vm._s(_vm.$t("uncertainty.Number of runs")) + ":"), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.modalUncertRuns),
      expression: "modalUncertRuns"
    }],
    staticClass: "txbox",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.modalUncertRuns)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.modalUncertRuns = $event.target.value
      }
    }
  }), _c('br')]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('button', {
    staticClass: "btn __green",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        _vm.runScens(_vm.modalUncertRuns) | _vm.$modal.hide('uncert-nruns')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("scenarios.Run scenarios")) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "btn __red",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "click": function($event) {
        return _vm.$modal.hide('uncert-nruns')
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t("Cancel")) + "\n        ")])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39680de3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/ScenariosPage.vue
// module id = 371
// module chunks = 1